import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {EntityModule} from './entityModule';
import {OilNodeData} from '@/views/services/oilAnalysis/interfaces';

/*
    Динамический модуль хранилища vuex для работы с анализами масел
*/

const moduleName = 'oilModule';

function transformGet(elem: any): OilNodeData {
  return {
    id: elem.id,
    name: elem.name,
    description: elem.description,
    nodeId: elem.node_id,
    measurements: elem.measurements?.map((m: any) => ({
      id: m.module_type_measurement_id,
      name: m.module_type_measurement_description,
      topWarningBoundary: m.top_warning_boundary,
      topDangerBoundary: m.top_danger_boundary,
      topErrorBoundary: m.top_error_boundary,
      bottomWarningBoundary: m.bottom_warning_boundary,
      bottomDangerBoundary: m.bottom_danger_boundary,
      bottomErrorBoundary: m.bottom_error_boundary,
    })),
  };
}

function transformCreateEdit(elem: any): OilNodeData {
  return {
    name: elem.name,
    description: elem.description,
    nodeId: elem.node_id,
    measurements: elem.measurements?.map((m: any) => ({
      id: m.module_type_measurement_id,
      name: m.module_type_measurement_description,
      topWarningBoundary: m.top_warning_boundary,
      topDangerBoundary: m.top_danger_boundary,
      topErrorBoundary: m.top_error_boundary,
      bottomWarningBoundary: m.bottom_warning_boundary,
      bottomDangerBoundary: m.bottom_danger_boundary,
      bottomErrorBoundary: m.bottom_error_boundary,
    })),
  };
}

function transformSave(model: OilNodeData): any {
  return {
    name: model.name,
    description: model.description,
    node_id: model.nodeId,
    measurements: model.measurements?.map((m: any) => ({
      module_type_measurement_id: m.id,
      module_type_measurement_description: m.name,
      top_warning_boundary: m.topWarningBoundary,
      top_danger_boundary: m.topDangerBoundary,
      top_error_boundary: m.topErrorBoundary,
      bottom_warning_boundary: m.bottomWarningBoundary,
      bottom_danger_boundary: m.bottomDangerBoundary,
      bottom_error_boundary: m.bottomErrorBoundary,
    })),
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class OilModule extends EntityModule {
  protected routeName = 'oil-nodes';

  get all(): OilNodeData[] {
    return super.all as OilNodeData[];
  }

  //Получение списка объектов с сервера
  @Action({rawError: true})
  public async fetchAll() {
    return await super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: OilNodeData}> {
    const transformData: OilNodeData = {name: '', description: '', nodeId: 0, measurements: []};
    return {data: transformData};
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: OilNodeData}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: OilNodeData}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: OilNodeData) {
    return super.save(model, transformSave);
  }

  //Удаление узла (в базовом классе)
}

export default getModule(OilModule);
